import React from 'react';
import '../StylesComponents/design-system.css';

function AboutPage() {
  return (
    <div className="about-page-container" style={{ padding: '28px 20px', color: 'var(--text-primary)', maxWidth: '1000px', margin: '0 auto' }}>
      <header style={{ marginBottom: '60px' }}>
        <div style={{ color: 'var(--accent-primary)', fontSize: '12px', marginBottom: '10px', fontFamily: 'monospace' }}>
          INITIATIVE_MANIFESTO // AUSTRALIA_2026
        </div>
        <h1 style={{ fontSize: 'clamp(3rem, 10vw, 5rem)', fontWeight: '900', letterSpacing: '-3px', lineHeight: '0.9', marginBottom: '20px' }}>
          REDEFINING THE <br /><span style={{ color: 'var(--accent-primary)' }}>SAVINGS</span> EXPERIENCE
        </h1>
      </header>

      <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
        <div style={{ borderLeft: '2px solid var(--accent-primary)', paddingLeft: '30px' }}>
          <h3 style={{ fontSize: '14px', letterSpacing: '2px', color: '#666', marginBottom: '20px' }}>WHY_WE_EXIST</h3>
          <p style={{ fontSize: '1.25rem', lineHeight: '1.5', fontWeight: '500' }}>
            We're living through an era where the cost of looking good has become a luxury most can't justify. 
            Everything is more expensive, but your wardrobe shouldn't be the sacrifice. 
            Stockroom was built to be the antidote to an inflated economy, a place where full price simply doesn't exist.
          </p>
        </div>

        <div style={{ background: 'rgba(0, 230, 118, 0.03)', padding: '40px', border: '1px solid rgba(0, 230, 118, 0.1)' }}>
          <h3 style={{ fontSize: '14px', letterSpacing: '2px', color: 'var(--accent-primary)', marginBottom: '20px' }}>OUR_COMMITMENT</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '1rem', lineHeight: '2' }}>
            <li style={{ borderBottom: '1px solid #1a1a1a', marginBottom: '10px' }}>
              <span style={{ color: '#444' }}>01 //</span> NO_FULL_PRICE_EVER
            </li>
            <li style={{ borderBottom: '1px solid #1a1a1a', marginBottom: '10px' }}>
              <span style={{ color: '#444' }}>02 //</span> QUALITY_OVER_HYPE
            </li>
            <li style={{ borderBottom: '1px solid #1a1a1a', marginBottom: '10px' }}>
              <span style={{ color: '#444' }}>03 //</span> FOR_THE_PEOPLE
            </li>
          </ul>
        </div>
      </section>

      <section style={{ marginTop: '80px', borderTop: '1px solid #1a1a1a', paddingTop: '60px' }}>
        <div style={{ maxWidth: '750px' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '900', marginBottom: '30px' }}>FAIR FASHION.</h2>
          <p style={{ color: '#888', lineHeight: '1.7', fontSize: '1.1rem' }}>
            We believe that finding a bargain shouldn't feel like a second job. 
            Our system scans Australian retailers 24/7 to find premium pieces that have been marked down, 
            stripping away the noise so you only see the savings. 
            By simplifying the path from the rack to your front door, we ensure you stay focused on your style while we focus on your bottom line. 
            In an economy that's working against you, Stockroom is working for you.
          </p>
        </div>
      </section>

      <footer style={{ marginTop: '100px', display: 'flex', gap: '40px', fontSize: '12px', fontFamily: 'monospace', color: '#444' }}>
        <div>LOC // PERTH_AU</div>
        <div>STATUS // OPERATIONAL</div>
      </footer>
    </div>
  );
}

export default AboutPage;
